<div class="contact-sales-dialog">

  <!-- Header -->
  <div class="dialog-header">
    <div>
      <h2>Contactar con ventas</h2>
      <p>¿Necesitas más capacidad? Diseñamos un plan enterprise a medida para tu negocio.</p>
    </div>
  </div>

  <!-- Form -->
  <div class="dialog-content" *ngIf="result === null">
    <div class="form-row">
      <div class="mb-3">
        <label>Nombre *</label>
        <input type="text" class="form-control" [(ngModel)]="contact.name" placeholder="Tu nombre" />
      </div>
      <div class="mb-3">
        <label>Empresa</label>
        <input type="text" class="form-control" [(ngModel)]="contact.company" placeholder="Nombre de tu empresa" />
      </div>
    </div>
    <div class="form-row">
      <div class="mb-3">
        <label>Teléfono</label>
        <input type="text" class="form-control" [(ngModel)]="contact.phone" placeholder="Teléfono de contacto" />
      </div>
      <div class="mb-3">
        <label>Correo electrónico *</label>
        <input type="email" class="form-control" [(ngModel)]="contact.email" placeholder="tu@email.com" />
      </div>
    </div>
  </div>

  <!-- Resultado OK -->
  <div class="dialog-result result-ok" *ngIf="result === 'ok'">
    <mat-icon>check_circle</mat-icon>
    <h3>¡Mensaje enviado!</h3>
    <p>Pronto nos pondremos en contacto contigo. ¡Muchas gracias!</p>
  </div>

  <!-- Resultado Error -->
  <div class="dialog-result result-error" *ngIf="result === 'error'">
    <mat-icon>error_outline</mat-icon>
    <h3>Ha ocurrido un error</h3>
    <p>Por favor, inténtalo de nuevo más tarde.</p>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button type="button" class="btn-cancel-dialog" (click)="closeDialog()">Cerrar</button>
    <button
      type="button"
      class="btn btn-convfact"
      *ngIf="result === null"
      [disabled]="isSending || !contact.name || !contact.email"
      (click)="sendContact()">
      {{ isSending ? 'Enviando...' : 'Contactar' }}
    </button>
  </div>

</div>
